export const YUBIKEY_LIST_MAX_CAPACITY = 5;
